const LottieAnimationProperty = {
    fill: 'fl',
    stroke: 'st'
};

class LottieAnimationRecolor {

    constructor(animationData, recolorObjects) {
        // recolorObjects format
        // [{
        //  layerName: "Name of layer"
        //  property: LottieAnimationProperty
        //  pathName: "Name of path"            ,
        //  colorString: "#RRGGBB" or "rgb(rrr, ggg, bbb)" - applies one color to all objects found
        //}]
        //
        var newAnimationData = JSON.parse(JSON.stringify(animationData)); //create a copy of the object. Object.assign was not creating a new instance for some reason.

        recolorObjects = recolorObjects || [];

        for (let l = recolorObjects.length, i = 0; i < l; i++) {
            var recolorObject = recolorObjects[i];

            if (recolorObject) {

                // find the shape object with the given path name
                var foundLayerObject = this.findLayerObject(newAnimationData, recolorObject.layerName);

                if (foundLayerObject) {
                    var foundShapeObject = this.findShapeWithPath(foundLayerObject, recolorObject.pathName);

                    if (foundShapeObject) {
                        this.recolorPathObject(foundShapeObject, recolorObject.property, recolorObject.colorString);
                    }
                }
            }
        }

        return newAnimationData;
    }

    // parses colors from #RRGGBB or rgb/rgba formats
    parseRGBColor(colorString) {
        var red, green, blue, alpha;

        // #RRGGBB (hex)
        if (colorString[0] == "#") {
            red = parseInt(`${colorString[1]}${colorString[2]}`, 16);
            green = parseInt(`${colorString[3]}${colorString[4]}`, 16);
            blue = parseInt(`${colorString[5]}${colorString[6]}`, 16);
        } // rgb(rrr, ggg, bbb)
        else if (colorString.substring(0, 3).toLowerCase() == "rgb") {
            var openParenthIndex = colorString.indexOf("(") + 1;
            var closeParenthIndex = colorString.indexOf(")");
            var rgbSubString = colorString.substring(openParenthIndex, closeParenthIndex);
            var colorSplit = rgbSubString.split(",");

            red = parseInt(colorSplit[0]);
            green = parseInt(colorSplit[1]);
            blue = parseInt(colorSplit[2]);

            if (colorSplit.length > 3) {
                alpha = parseFloat(colorSplit[3]);
            }

        } else {
            throw "Invalid color string " + colorString;
        }

        return {
            red: red,
            green: green,
            blue: blue,
            alpha: alpha
        };
    };

    // converts the color objects from parseRGBColor into a format Lottie likes which is [r/255, g/255, b/255, alpha]
    convertRGBColorLottie(rgbColor) {
        return [rgbColor.red / 255, rgbColor.green / 255, rgbColor.blue / 255];
    }

    // finds the shapes by the given name
    findLayerObject(animationData, layerName) {
        layerName = layerName.toLowerCase();
        var returnLayer = animationData.layers.filter(l => {
            return l.nm.toLowerCase() == layerName;
        })[0];

        if (!returnLayer) {
            console.log("No layer by the name " + layerName + " found!");
        }

        return returnLayer;
    }

    findShapeWithPath(layerObject, pathName) {
        pathName = pathName.toLowerCase();

        var reutrnShape = layerObject.shapes.filter(s => {
            if (s.ty == 'gr') {
                return s.it.filter(i => {
                    return i.nm.toLowerCase() == pathName;
                })[0];
            }
        })[0];

        if (!reutrnShape) {
            console.log("No path by the name " + pathName + " found!");
        }

        return reutrnShape;
    }

    convertAlphaLottie(value) {
        return value * 100;
    }

    // reassigns a color
    recolorPathObject(shapeObject, property, colorString) {
        var parsedColor = this.parseRGBColor(colorString);
        var recolorProperty = shapeObject.it.filter(i => {
            return i.ty.toLowerCase() == property;
        })[0];

        if (recolorProperty) {
            var lottieColor = this.convertRGBColorLottie(parsedColor);
            recolorProperty.c.k = lottieColor;

            if (!isNaN(parsedColor.alpha)) {
                recolorProperty.o.k = this.convertAlphaLottie(parsedColor.alpha);
            }
        }
    }
};

export { LottieAnimationRecolor, LottieAnimationProperty };


// WEBPACK FOOTER //
// ./src/images/animations/lottie/LottieAnimationRecolor.js